import { render } from "./NavItem.vue?vue&type=template&id=772a0192&ts=true"
import script from "./NavItem.vue?vue&type=script&lang=ts"
export * from "./NavItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__